import React, {Component} from 'react';
import ReactDOM from 'react-dom';

class InstagramFeeds extends Component {
  constructor(props) {
    super(props);
  }

  renderFeedItem(feed, content) {
    if (feed.link) {
      return (
        <a href={feed['link']}
           className="feed-image"
           style={{backgroundImage: `url(${feed['image']})`}}
           target="_blank"
           rel="noopener noreferrer"
        >
          {content}
        </a>
      );
    }

    return (
      <div className="feed-image"
           style={{backgroundImage: `url(${feed['image']})`}}
      >
        {content}
      </div>
    );
  }

  render() {
    const { instagramFeeds } = window.Ode;

    return (
      <React.Fragment>
        {instagramFeeds.length > 0 && (
          <div className="marquee-inner">
            {[1, 2].map((key) => {
              const animationDuration = instagramFeeds.length * 10;
              let animationDelay = animationDuration * -1;

              if (key === 1) {
                animationDelay = (animationDuration / 2) * -1;
              }

              const marqueeStyle = {
                animationDuration: animationDuration + 's',
                animationDelay: animationDelay + 's',
              };

              return (
                <div className={`marquee-block-${key}`} key={key} style={marqueeStyle}>
                  {instagramFeeds.map((feed, key) => {
                    return (
                      <div className="feed-item" key={key}>
                        {
                          this.renderFeedItem(feed,
                            <React.Fragment>
                              {feed['caption'].length > 0 && (
                                <div className="feed-content">
                                  <div className="actual-content" dangerouslySetInnerHTML={{__html: feed['caption']}}/>
                                </div>
                              )}
                            </React.Fragment>
                          )
                        }
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default {
  init() {
  },
  finalize() {
    const socialMarquee = $('.social-marquee');
    if (socialMarquee.length) {
      ReactDOM.render(<InstagramFeeds/>, socialMarquee[0]);
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/modules/loadInstagramFeeds.js